<template>
    <div class="page">
      <div class="main">
        <img src="@/assets/img/mobile.png" alt="" class="mobile"/>
        <div class="login">验证码已通过短信发送至：</div>
        <div class="login">{{userPhone}}</div>
        <div class="ph-input">
            <!-- <van-password-input
            :value="smsCode"
            :mask="false"
            :gutter="20"
            :length="4"
            :focused="showKeyboard"
            @focus="showKeyboard = true"
          /> -->
          <tcode ref="tcode"/>
        </div>
        <span class="getCode" @click="getMobileCode">{{text}}</span>
        <van-button class="bu_tn-a" round block type="info" native-type="submit" @click="onSubmit">立即登录</van-button>
      </div>
      <!-- <van-number-keyboard v-model="smsCode" id="keyboardDefined" :z-index="2015" :show="showKeyboard" :maxlength="4" @input="onInput" @delete="onDelete" @blur="showKeyboard = false" /> -->
    </div>
  </template>
  <script>
  import { wxRequest } from '@/api/user'
  import { Toast } from 'vant'
  import mixins from '@/mixins/mixins.js'
  import tcode from '@/components/code.vue'
  export default {
    components: {
        tcode
    },
    data() {
      return {
        userPhone: null,
        showKeyboard: true,
        smsCode:'',
        text:'获取验证码',
        countdown:true,
        code:''
      }
    },
    mixins:[mixins],
    mounted() {
       this.userPhone = this.$route.query.userPhone
       this.code = this.$route.query.code
       this.countDown();
    },
    beforeDestory() {
        clearInterval(this.timer)
    },
    methods: {
        onInput(key) {
            this.smsCode = (this.smsCode + key).slice(0, 6);
        },
        onDelete() {
            this.smsCode = this.smsCode.slice(0, this.smsCode.length - 1);
        },
        countDown() {
            const TIME_COUNT = 60
            if (!this.timer) {
                this.count = TIME_COUNT
                this.countdown = false
                this.timer = setInterval(() => {
                    if (this.count > 0) {
                        this.count--
                        this.text = this.count + 'S后重新获取'
                    } else {
                        clearInterval(this.timer)
                        this.text ='获取验证码'
                        this.countdown = true
                        this.timer = null
                    }
                }, 1000)
            }
        },
        getMobileCode() {
            if(!this.countdown) return
            if (!(/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this.userPhone))) {
                Toast('请填写正确的手机号')
                return
            }
            wxRequest('/bindPhone/sms/code', { userPhone: this.userPhone }, 'post').then(res => {
                if (res.data.code === '200') {
                    this.countDown()
                    Toast.success('发送成功')
                } else {
                    Toast.fail(res.data.message)
                }
            })
        },
        onSubmit(){
            this.smsCode = this.$refs.tcode.codeArr.join('')
            if (this.smsCode.length < 3) {
                Toast('验证码有误，请重新填写')
                return
            }
            wxRequest('/bindPhone/bind/phone/checkout', { userPhone: this.userPhone,smsCode:this.smsCode }, 'post').then(res => {
                if (res.data.code === '200') {
                    if(res.data.data&&res.data.data.length>5){
                        this.nextClick(res.data.data,this.userPhone,this.code,0,1);
                    }else{
                      this.$router.push({ path: "/newUser/bindNew/bindingCard",query: {userPhone: this.userPhone}})
                    }
                } else {
                    Toast.fail(res.data.message)
                }
            })
        }
    }
  }
  </script>
  <style lang="less" scoped>
  .page{
    background: #fff;
    height:100% ;
    .main{
        padding-top:66px;
        flex: 1;
        display: flex;
        align-items: stretch;
        flex-direction: column;
        .mobile{
            margin-left: 27px;
            margin-bottom: 28px;
            width: 180px;
            height: 58px;
        }
        .login{
            font-size: 15px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            letter-spacing: 1px;
            margin-left: 27px;
            margin-bottom:10px;
        }
        input {
            margin-right: 20px;
            width: 45px;
            text-align: center;
            border: none;
            border-bottom: 1px solid #212121;
            font-size: 24px;
            outline: none;
            background: none;
        }
        input:last-of-type {
            margin-right: 0;
        }
        input:disabled {
            color: #000;
            background-color: #fff;
        }
    
        .ph-input{
            width: 361px;
            /* height: 49px; */
            background: #fff;
            border-radius: 2px;
            margin: 72px auto 0;
            display: flex;
            align-items: center;
            .van-password-input{
                width: 100%;
                li{
                    background: #f3f7fe;
                }
            }
        }
    }
    .bu_tn-a{
        width: 316px;
        height: 49px;
        border-radius: 30px;
        font-size: 19px;
        color: #fff;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 500;
        line-height: 49px;
        letter-spacing: 1px;
        text-align: center;
        background: #3483fe;
        margin: auto auto 30px auto;
    }
    .getCode{
        color: #3c9cff;
        display: block;
        text-align: right;
        padding-bottom:50px;
        margin-right:22px;
        cursor: pointer;
    }
}
</style>
  
  